import { useState } from "react";
import { useTranslation } from "react-i18next";
import SubSections from "../SubSections";

interface IAttractions {
  property: {
    attractions: [];
  }
  name?: string;
}
export const Attractions: React.FC<IAttractions> = (props) => {
  const { t } = useTranslation();
  const [isAmenities, showAmenities] = useState(false);
  const [countAmenities, updateCount] = useState(2);
  const count = props.property.attractions.length;
  const amenitiesOther = () => {
    return props.property.attractions.length - 2;
  };
  const showAllAmentities = (show: boolean, count: number) => {
    showAmenities(show);
    updateCount(count);
  };
  return (
    <SubSections
      title={props.name}
      subtitle="Free Wi-Fi  |  Pool  |  AC  |  Kitchen  |  TV"
      others="+10 0thers"
    >
      {props.property.attractions?.map((item, index) => (
        index < countAmenities && (
          <span key={index}>
            <span>{item}</span>
            {count > 1 && (count - 1 !== index) && <span className="other-bar"> | </span>}
          </span>
        )
      ))}
      {!isAmenities && props.property.attractions.length > 2? (
        <span className="others" onClick={() => showAllAmentities(true, 20)}>
          +{amenitiesOther()} {t('resultCard.others')}
        </span>
      ) : !isAmenities && props.property.attractions.length <= 2 ? (
        <></>
      ) : (
        <span className="others" style={{ marginLeft: '5px' }} onClick={() => showAllAmentities(false, 2)}>
          {t('resultCard.showLess')}
        </span>
      )}
    </SubSections>
  );
};
